import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { first, firstValueFrom, isEmpty } from 'rxjs';
import { DataService } from './../../../services/data/data.service';
import Swal from 'sweetalert2';
import { CookieService } from 'ngx-cookie-service';
import { ConstantesImagenes } from '../../../../app/models/Cuestionarios/codigoimagenes';
import { messages } from '../../funciones/mensajes';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import pdfMake from 'pdfmake/build/pdfmake';
pdfMake['vfs'] = pdfFonts;

//consultas
import { environment } from './../../../../environments/environment';
import { Apollo } from 'apollo-angular';
import { Subscription } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';

//servicios
import { getCuestionarioPorId, getCuestionariosInfo, getEstatusHoja, getHojaRespuesta } from './../../../services/Administrador/cuestionarios/query';
import { getAsignaciones, getInstituciones } from '../../../services/Administrador/asignaciones/asignaciones';
import { AsignacionesService } from '../../../services/Administrador/asignaciones/asignaciones.service';
import { } from '../../../services/cuestionarios/cuestionario/query';
import { HojaRespuestasService } from '../../../services/cuestionarios/cuestionario/hoja-respuestas.service';
import { pagination } from '../../../entities/base/DashboardEntities';

@Component({
  selector: 'app-asignacion',
  templateUrl: './asignacion.component.html',
  styleUrl: './asignacion.component.css'
})
export class AsignacionComponent {
  private querySubscription: Subscription;
  private headers = new HttpHeaders().append('Authorization', 'Bearer ' + localStorage.getItem('token'));
  private messageComp = '<br/><br/><div> <span style="text-aling: center;font-size: 10pt;font-weight: 200;">Presione</span>' +
    '<span style="text-aling: center;font-size: 10pt;font-weight: 600;"> esc </span>' +
    '<span style="text-aling: center;font-size: 10pt;font-weight: 200;">para cerrar</span></div>';

  public tabla = true;
  public nuevaAsig = new FormGroup({
    cuestionario: new FormControl('', [Validators.required]),
    institucion: new FormControl('', [Validators.required]),
    fechaIni: new FormControl('', [Validators.required]),
    fechaFin: new FormControl('', [Validators.required]),
    nombreRes: new FormControl('', [Validators.required]), //
    cargo: new FormControl('', [Validators.required]), //
    correo: new FormControl('', [Validators.email, Validators.required]) //
  });
  valoresDefault = {
    cuestionario: '',
    institucion: '',
    fechaIni: '',
    fechaFin: '',
    nombreRes: '',
    cargo: '',
    correo: "",
  }
  public cuestionarios = [];
  public instituciones = []
  public columnas = ['id', 'inst', 'cuesAsigName', 'fechaIni', 'fechaFin', 'responsable', 'estatus', 'reporte', 'funciones']
  public cuesAsignados = [];
  public mostrarAsig;
  public fechaAct;
  public edicion = false;
  public elemEdicion;
  private cuesSelec;
  private cuestionario: any = [];
  private hojaRespuesta = [];
  private semaforos = [];
  public reporteGeneradoExitosamente: boolean = true;
  public isDownloadingPdf = false;
  private reportName = 'Reporte.pdf';
  private pdfFile: any;
  private imgLogo;
  public loadingAsignaciones = false;
  constructor(
    public dataService: DataService,
    private translate: TranslateService,
    private apollo: Apollo,
    private cookieService: CookieService,
    private asignacionesService: AsignacionesService,
    private imageService: HojaRespuestasService
  ) {
    this.getLogo();

  }

  ngOnInit() {
    this.fechaAct = moment().format("YYYY-MM-DD");
    this.ListQuestionnaires();
    // this.getDataAsignaciones()
  }

  private async ListQuestionnaires() {
    try {
      const { data } = await firstValueFrom(
        this.apollo.use(environment.api_cuestionarios).watchQuery<any>({
          query: getCuestionariosInfo,
          context: { headers: this.headers, },
          variables: {
            args: {
              relations: {
                loadRelations: "BASIC"
              },
              pagination: {
                isUnlimit: true
              },
              filter: {
                operator: "AND",
                conditions: [
                  {
                    field: "status",
                    operator: "EQUAL",
                    value: "ready"
                  }
                ]
              },
            },
          }
        }).valueChanges
      );

      this.cuestionarios = [];
      if (data.questionnaires && Array.isArray(data.questionnaires)) {
        for (const cuestionario of data.questionnaires) {
          this.cuestionarios.push({
            id: Number(cuestionario.id),
            name: cuestionario.name,
            nombreCorto: cuestionario.shortName,
            allowMultipleAnswers: cuestionario.allowMultipleAnswers || false
          });
        }
      }

      this.getDataAsignaciones();
    } catch (err) {
      messages.errorMessageGraph(err);

    }
  }

  public async mensaje(txt, icon) {
    txt = this.translate.instant(txt) + this.messageComp;
    Swal.fire({
      html: txt,
      icon: icon,
      showCancelButton: false,
      showConfirmButton: false,
    });

  }

  private async getDataAsignaciones() {
    //aqui van las consultas para la obtencion de los catalogos de cuestionarios, instituciones, etc.
    this.loadingAsignaciones = true;
    try {
      const asig = await firstValueFrom(
        this.apollo.use(environment.api_cuestionarios).watchQuery<any>({
          query: getAsignaciones,
          context: { headers: this.headers, },
          variables: {
            args: {
              pagination: {
                limit: null,
              }
            }
          },
        }).valueChanges.source
      );
      this.cuesAsignados = [];
      for (const as of asig.data.allocations) {
        const q = as.questionary || as.questionnaire || null;

        var est = '';
        try {
          const estatusHoja = await firstValueFrom(
            this.apollo.use(environment.api_cuestionarios).watchQuery<any>({
              query: getEstatusHoja,
              context: { headers: this.headers, },
              variables: { allocationId: Number(as.id) },
              fetchPolicy: 'no-cache',
            }).valueChanges.source
          );
          if (as.status == 'open' && estatusHoja.data.findAnswerSheet.status == 'uncompleted') {
            est = 'open';
          } else {
            est = 'close';
          }
        } catch (e) {
          if (as.status == 'open') {
            est = 'open';
          } else {
            est = 'close';
          }
        }
        this.cuesAsignados.push({
          id: Number(as.id),
          inst: as.institution_id,
          cuesAsigId: q ? Number(q.id) : null,
          cuesAsigName: q ? q.name : null,
          fechaIni: moment(as.start_date).format("DD/MM/YYYY"),
          fechaFin: moment(as.due_date).format("DD/MM/YYYY"),
          responsable: as.responsible_full_name,
          cargo: as.responsible_role,
          correo: as.responsible_email,
          estatus: est,
          // null = nunca se capturó; 0 es un valor válido capturado
          encuestasEnviadas: as.sent_surveys_count ?? null,
        });
      }
      try {
        const inst = await firstValueFrom(
          this.apollo.use(environment.api_cuestionarios).watchQuery<any>({
            query: getInstituciones,
            context: { headers: this.headers, },
            variables: {}
          }).valueChanges.source
        );
        for (const i of inst.data.findAll_institutions) {
          this.instituciones.push({ id: i.id, name: i.company_name });
        }
      } catch (e) {
        messages.errorMessageGraph(e);
      }
      this.mostrarAsig = JSON.parse(JSON.stringify(this.cuesAsignados));
    } catch (err) {
      messages.errorMessageGraph(err);
    } finally {
      this.loadingAsignaciones = false;
    }
  }

  public filtroCuestionario() {
    const id = Number(document.getElementById('cuestionario')['value']);
    if (!isNaN(id)) {
      this.mostrarAsig = JSON.parse(JSON.stringify(this.cuesAsignados.filter(i => i.cuesAsigId === id)));
    } else {
      this.mostrarAsig = JSON.parse(JSON.stringify(this.cuesAsignados));
    }
  }

  public obtenerNombre(id) {
    return this.instituciones.filter(i => i.id === id)[0].name;
  }

  public async nuevaAsignacion(accion, elem?) {
    if (accion == 'abrir') {
      this.tabla = false;
    }
    if (accion == 'cancel') {
      this.tabla = true;
      this.edicion = false;
      this.nuevaAsig.reset(this.valoresDefault);
    }
    if (accion == 'guardar') {
      const cues = this.nuevaAsig.controls['cuestionario'].value;
      const ins = this.nuevaAsig.controls['institucion'].value;
      const fecIn = this.nuevaAsig.controls['fechaIni'].value;
      const fecFin = this.nuevaAsig.controls['fechaFin'].value;
      const respon = this.nuevaAsig.controls['nombreRes'].value;
      const cargo = this.nuevaAsig.controls['cargo'].value;
      const correo = this.nuevaAsig.controls['correo'].value;

      if (!this.edicion) {//nueva asignacion
        var asig = {
          id: null,
          inst: ins,
          cuesAsigId: Number(cues),
          fechaIni: moment(fecIn).format("MM-DD-YYYY"),
          fechaFin: moment(fecFin).format("MM-DD-YYYY"),
          responsable: respon,
          cargo: cargo,
          correo: correo,
          estatus: 'open',
        }
        // aqui se envia la consulta para guardar la nueva asignacion
        try {
          const resp = await firstValueFrom(this.asignacionesService.postAsignaciones(asig));
          asig.id = resp['data'].id;
          const c = this.cuestionarios.find(c => c.id == asig.cuesAsigId);
          asig['cuesAsigName'] = c.name;
          asig.fechaIni = moment(fecIn).format("DD/MM/YYYY"),
            asig.fechaFin = moment(fecFin).format("DD/MM/YYYY"),
            this.cuesAsignados.push(asig);
        } catch (err) {
          messages.errorMessageGraph(err);
          return;
        }
      } else {//edicion asignacion existente
        //aqui se modifica el registro existente de la asignacion
        var ed = this.cuesAsignados.find(c => c.id === this.elemEdicion.id);
        ed.fechaFin = moment(fecFin).format("MM-DD-YYYY");
        try {
          const resp = await firstValueFrom(this.asignacionesService.patchAsignaciones(ed));
          ed.fechaFin = moment(fecFin).format("DD/MM/YYYY");
          // Si la nueva fecha fin ya pasó, se cierra automáticamente la asignación
          if (ed.estatus === 'open' && moment(fecFin).isBefore(moment(), 'day')) {
            try {
              await firstValueFrom(this.asignacionesService.changeStatusAsignacion(ed.id, 'closed'));
              ed.estatus = 'close';
            } catch (err) {
              //messages.errorMessageGraph(err);
            }
          } else if (ed.estatus === 'close' && moment(fecFin).isAfter(moment(), 'day')) {
            try{
              await firstValueFrom(this.asignacionesService.changeStatusAsignacion(ed.id, 'open'));
              ed.estatus = 'open';
            } catch (err) {
              //messages.errorMessageGraph(err);
            }
          }
        } catch (err) {
          messages.errorMessageGraph(err);
          return;
        }
      }

      messages.succesMessageGraph(this.translate.instant('cues.asignacion.guardadoExitoso'));
      this.tabla = true;
      this.nuevaAsig.reset(this.valoresDefault);
    }
    if (accion == 'editar') {
      this.nuevaAsig.controls['cuestionario'].setValue(elem.cuesAsigId);
      this.nuevaAsig.controls['institucion'].setValue(elem.inst);
      this.nuevaAsig.controls['fechaIni'].setValue(moment(elem.fechaIni, 'DD/MM/YYYY').format("YYYY-MM-DD"));
      this.nuevaAsig.controls['fechaFin'].setValue(moment(elem.fechaFin, 'DD/MM/YYYY').format("YYYY-MM-DD"));
      this.nuevaAsig.controls['nombreRes'].setValue(elem.responsable);
      this.nuevaAsig.controls['cargo'].setValue(elem.cargo);
      this.nuevaAsig.controls['correo'].setValue(elem.correo);
      this.edicion = true;
      this.elemEdicion = elem;
      this.tabla = false;
    }
    if (accion == 'eliminar') {
      const guardo = await messages.confirmationSave(
        this.translate.instant('Eliminar asignación'),
        this.translate.instant('¿Deseas continuar?'),
        this.translate
      );
      if (guardo) {
        try {
          const resp = await firstValueFrom(this.asignacionesService.deleteAsignaciones(elem.id));
          this.cuesAsignados = this.cuesAsignados.filter(i => i.id !== elem.id);
        } catch (err) {
          messages.errorMessageGraph(err);
          return;
        }
        messages.succesMessageGraph(this.translate.instant('cues.asignacion.eliminacion'))
      }
    }
    this.mostrarAsig = JSON.parse(JSON.stringify(this.cuesAsignados));

  }
  public puedeGuardar() {
    if (this.nuevaAsig.valid) {
      return '';
    } else {
      return 'w3-disabled'
    }
  }

  public getFecha(fec) {
    return moment(fec, 'DD/MM/YYYY').format("MMM YYYY");
  }

  public async descargarReporte(cues) {
    //aqui se realizara el llamada para generar el reporte recibe como dato el id de la asignacion 
    try {

      Swal.fire({
        title: '' + this.translate.instant('acciones.descarga'),
        html: '' + this.translate.instant('acciones.espera'),
        timerProgressBar: true,
        didOpen: () => {
          Swal.showLoading(undefined);
        },
      });
      this.cuesSelec = cues;
      await this.getHojaRespuestas();
      this.isDownloadingPdf = true;
      this.reporteGeneradoExitosamente = false;
      const fechaPiePag = new Date().toLocaleDateString('es-MX', { month: '2-digit', day: '2-digit', year: '2-digit', });
      const horaPiePag = new Date().toLocaleTimeString('es-MX');
      const currentUser = this.dataService.user;
      const colorCalif = this.semaforos.find(s => s.min <= this.cuestionario['ponderacion'] && this.cuestionario['ponderacion'] <= s.max).color
      const docPDF = {
        pageSize: 'FOLIO',
        images: {
          logoAleema: ConstantesImagenes.fondoblanco,
        },
        footer: function (currentPage, pageCount) {
          if (currentPage == 1) {
            return null;
          }
          if (currentPage === pageCount) {
            return {
              columns: [
                {
                  image: 'logoAleema',
                  width: 70,
                  margin: [30, -1, 30, 0],
                },
                {
                  text: `${currentUser}  |  ${fechaPiePag}  |  ${horaPiePag}`,
                  alignment: 'center',
                  width: '*',
                  color: '#808080',
                  fontSize: 10,
                },

                {
                  text: (currentPage - 1).toString(),
                  color: '#808080',
                  fontSize: 10,
                  width: 'auto',
                  margin: [10, -1, 30, 0],
                },
              ]
            }
          } else {
            return {
              text: {
                text: (currentPage - 1).toString(),
                alignment: 'right',
                color: '#808080',
                fontSize: 10,
                width: 'auto',
              }, margin: [10, -1, 30, 0],
            }
          }
        },
        content: [
          this.imgLogo !== '' && this.imgLogo !== undefined ? {
            image: this.imgLogo,
            width: 220,
            margin: [0, 0, 10, 0],
            absolutePosition: { y: 60 },
            alignment: 'right',
          } : { text: '' },
          {
            text: 'Resultados',
            style: 'header',
            bold: true,
            fontSize: 30,
            color: 'black',
            margin: [60, 250, 0, 0],
          },
          {
            text: this.cuesSelec.cuesAsigName,
            style: 'header',
            bold: true,
            fontSize: 30,
            color: 'black',
            margin: [60, 5, 0, 0],
          },
          {
            text: ['Calificación: ', { text: this.cuestionario['ponderacion'], color: colorCalif }],
            style: 'header',
            bold: true,
            fontSize: 20,
            color: 'black',
            margin: [60, 25, 0, 0],
          },
          {
            text: this.getFecha(this.cuesSelec.fechaIni),
            style: 'header',
            bold: true,
            fontSize: 18,
            color: 'black',
            margin: [60, 45, 0, 0],
          },
          [
            { text: '', pageBreak: 'after' }
          ],
          this.introduccion(),
          [
            { text: '', pageBreak: 'after' }
          ],
          {
            table: this.formatCuestionario(this.cuestionario, 0),
            layout: {
              hLineColor: function (i) {
                return 'white';
              },
              vLineColor: function (i, node) {
                return 'white';
              },
            },
          },

        ]
      };

      this.reporteGeneradoExitosamente = true;

      this.reportName = 'Reporte ' + this.cuesSelec.cuesAsigName + '.pdf';

      const pdf = pdfMake.createPdf(docPDF);

      pdf.download(this.reportName);
      const blob = await pdf.getBlob();
      this.pdfFile = blob;
      Swal.close();
      this.mensaje('acciones.desExito', 'success')
      setTimeout(() => {
        this.isDownloadingPdf = false;
      }, 2000);
    } catch (error) {
      this.reporteGeneradoExitosamente = false;
      Swal.close();
      Swal.fire({ title: 'Error al generar el reporte', timer: 20000 });
    }
  }
  private introduccion() {
    var intro = [];
    var comp = [];
    var sem = [];
    for (const c of this.cuestionario['elementos']) {
      comp.push(
        [{
          alignment: 'justify',
          text: c.name,
          style: 'header',
          fontSize: 11,
          color: 'black',
          bold: true,
          border: [false, false, false, true],
          borderColor: ['white', 'white', 'white', '#44b3e1']
          // margin: [ 30, 10, 0, 0 ]
        }]
      )
    }
    for (const s of this.semaforos) {
      sem.push(
        [
          {
            text: '',
            fillColor: s.color
          },
          {
            text: s.name,
            style: 'header',
            fontSize: 11,
            color: 'black',
          },
          {
            text: s.min + ' - ' + s.max,
            style: 'header',
            fontSize: 11,
            color: 'black',
          }
        ]
      )
    }
    intro = [
      {
        text: this.translate.instant('cues.asignacion.controlInterno') + '\n\n',
        style: 'header',
        fontSize: 16,
        color: 'black',
        bold: true,
        margin: [20, 0, 0, 0],
      },
      {
        text: this.translate.instant('cues.asignacion.textControlInterno1') + ' ' +
          this.translate.instant('cues.asignacion.textControlInterno2') + ' ' +
          this.translate.instant('cues.asignacion.textControlInterno3'),
        style: 'header',
        fontSize: 12,
        color: 'black',
        bold: false,
        alignment: 'justify',
        margin: [30, 0, 0, 0],
      },
      {
        text: '\n\n' + this.translate.instant('cues.asignacion.tituloObjetivo') + '\n',
        style: 'header',
        fontSize: 16,
        color: 'black',
        bold: true,
        margin: [20, 10, 0, 0],
      },
      {
        ol: [
          this.translate.instant('cues.asignacion.objetivo1'),
          this.translate.instant('cues.asignacion.objetivo2')
        ],
        style: 'header',
        fontSize: 12,
        color: 'black',
        bold: false,
        alignment: 'justify',
        margin: [30, 0, 0, 0],
      },
      {
        text: '\n' + this.translate.instant('cues.asignacion.tituloMide') + '\n',
        style: 'header',
        fontSize: 12,
        color: 'black',
        bold: false,
        margin: [30, 10, 0, 0],
      },
      {
        ul: [
          this.translate.instant('cues.asignacion.mide1'),
          this.translate.instant('cues.asignacion.mide2'),
          this.translate.instant('cues.asignacion.mide3')
        ],
        style: 'header',
        fontSize: 12,
        color: 'black',
        bold: false,
        alignment: 'justify',
        margin: [30, 0, 0, 0],
      },
      {
        text: '\n' + this.translate.instant('cues.asignacion.tituloComp') + '\n',
        style: 'header',
        fontSize: 12,
        color: 'black',
        bold: false,
        margin: [30, 10, 0, 0],
      },
      {
        table: {
          headerRows: 1,
          widths: [250],
          body: comp,
        },
        margin: [30, 10, 0, 0],
        layout: {
          // hLineColor: function (i) {
          //   return '#44b3e1';
          // },
          vLineColor: function (i, node) {
            return 'white';
          },
        },
      },
      {
        text: '\n\n' + this.translate.instant('cues.asignacion.textPonderacion1') +
          this.translate.instant('cues.asignacion.textPonderacion2') + '\n',
        style: 'header',
        fontSize: 12,
        color: 'black',
        bold: false,
        margin: [30, 10, 0, 0],
      },
      {
        table: {
          headerRows: 1,
          widths: [20, 100, 50],
          body: sem,
        },
        margin: [160, 10, 0, 0],
        alignment: 'center',
        border: [false, false, false, false],
        layout: {
          hLineColor: function (i) {
            return 'white';
          },
          vLineColor: function (i, node) {
            return 'white';
          },
        },
      },
    ]

    return intro
  }
  private formatCuestionario(array, pos) {
    var col;

    let table: any = {
      headerRows: 1,
      widths: [460, 50],
      body: [],
    };

    if (pos === 0) {
      table.body.push([
        {
          text: '',
          style: 'header',
          bold: true,
        },
        {
          alignment: 'right',
          text: '',
          style: 'header',
          bold: true,
        },
      ]);
    }

    if (pos === 0) {
      col = 'black'
    } else {
      col = '#0455B2'
      // col = '#ACBD3D'
    }
    for (const c of array['elementos']) {
      var sem = this.semaforos.find(s => s.min <= c.ponderacion && c.ponderacion <= s.max).color;
      table.body.push([
        {
          text: c.name,
          style: 'header',
          fontSize: 15 - (2 * pos) < 12 ? 12 : 15 - (2 * pos),
          color: col,
          bold: true,
          margin: [20 * pos, 10, 0, 0],
        },
        {
          alignment: 'right',
          text: c.ponderacion,
          style: 'header',
          fontSize: 11,
          bold: true,
          color: sem,
          margin: [20 * pos, 10, 0, 0],
        },
      ]);
      if (c.elementos.length !== 0) {//el cuestionario tiene elementos
        const data = this.formatCuestionario(c, pos + 1);
        table.body = table.body.concat(data.body);
      } else {// el cuestionario no tiene elementos 
        for (const p of c.preguntas) {
          var res;
          var sem2 = this.semaforos.find(s => s.min <= p.ponderacion && p.ponderacion <= s.max).color;
          try {
            res = this.hojaRespuesta.find(r => r.idPregunta == Number(p.id));
            res = p.respuestas.find(r => r.id == res.idRespuesta);
          } catch (e) { }
          table.body.push([
            {
              alignment: 'justify',
              text: p.order + '. ' + p.descripcion,
              style: 'header',
              fontSize: 11,
              color: '#1f1f1f',
              margin: [20 * (pos + 1), 10, 0, 0]
            },
            {
              alignment: 'right',
              text: p.ponderacion,
              style: 'header',
              fontSize: 11,
              color: sem2,
              margin: [0, 10, 0, 0]
            },
          ]);
          table.body.push([
            {
              alignment: 'justify',
              text: 'Respuesta: ' + (res ? res.descrip : '-'),
              style: 'header',
              fontSize: 11,
              color: '#808080',
              margin: [20 * (pos + 1.5), 0, 0, 0]
            },
            {
              alignment: 'right',
              text: '',
              style: 'header',
              fontSize: 11,
              color: '#808080',
              margin: [0, 0, 0, 0]
            },
          ]);
        }
      }
    }
    return table;
  }
  private async getLogo() {
    try {
      const response = await firstValueFrom(this.imageService.getLogo(this.dataService.idInstitution));
      for (const doc of response) {
        const name = ('' + doc['filename']).split('.');
        const nomsep = name[0].split('_');

        for (const nam of nomsep) {
          if (nam.toLocaleLowerCase() === 'logo') {
            const responseArchivo = await firstValueFrom(this.imageService.getArchivosA(doc._id));
            var base = 'data:image/' + name[name.length - 1] + ';base64,' + btoa(new Uint8Array(response).reduce((data, byte) => data + String.fromCharCode(byte), ''));
            this.imgLogo = base;
            break;
          }
        }
      }
    } catch (error) {

    }
  }

  private async getHojaRespuestas() {
    // se valida en la base de datos si existe una hoja de respuestas para cargar las respuestas guardadas
    try {
      //existe hoja de respuesta previa
      const resp = await firstValueFrom(
        this.apollo.use(environment.api_cuestionarios).watchQuery<any>({
          query: getHojaRespuesta,
          context: { headers: this.headers, },
          variables: { allocationId: Number(this.cuesSelec.id) }
        }).valueChanges.source
      );
      for (const r of resp['data'].findAnswerSheet.answers) {
        this.hojaRespuesta.push({ idPregunta: Number(r.question.id), idRespuesta: r.answerOption.id })
      }
      await this.obtDataCuestionario();
    } catch (error) {
      //no existe hoja de respuesta previa 
      await this.obtDataCuestionario();
    }
  }
  private async obtDataCuestionario() {
    //aqui va la consulta para obtener toda la informacion relacionada al cuestionario 
    //preguntas respuestas y hoja de respuestas
    try {
      const res = await firstValueFrom(
        this.apollo.use(environment.api_cuestionarios).watchQuery<any>({
          query: getCuestionarioPorId,
          context: { headers: this.headers, },
          variables: {
            args: {
              relations: {
                loadRelations: "FULL"
              },
              filter: {
                operator: "AND",
                conditions: [
                  {
                    field: "id",
                    operator: "EQUAL",
                    value: "" + this.cuesSelec.cuesAsigId
                  }
                ]
              },
            },
          }
        }).valueChanges.source
      );
      this.cuestionario = {
        id: res.data.questionnaires[0].id,
        name: res.data.questionnaires[0].name,
        ponderacion: 0,
        elementos: this.ListelementosCategories(res.data.questionnaires[0].categories, null)
      }
      var peso = 0;
      for (const e of this.cuestionario['elementos']) {
        peso += e.ponderacion * e.peso / 100;
      }

      this.semaforos = [];
      var aux = JSON.parse(JSON.stringify(res.data.questionnaires[0].semaphores));
      aux.sort(function (a, b) {
        if (Number(a.value_1) < Number(b.value_1)) {
          return 1;
        }
        if (Number(a.value_1) > Number(b.value_1)) {
          return -1;
        }
        return 0;
      });
      var titN = 1;

      for (const sem of aux) {
        var name = this.translate.instant('cues.resultados.titulo-semaforo-' + titN);
        if (name === ('cues.resultados.titulo-semaforo-' + titN)) {
          name = '';
        }
        this.semaforos.push({
          name: name,
          min: sem.value_1,
          max: sem.value_2,
          color: sem.color
        });
        titN++;
      }

      peso = Number(peso.toFixed(1));
      this.cuestionario['ponderacion'] = peso;
    } catch (err) {
      messages.errorMessageGraph(err);
    }
  }

  private ListelementosCategories(elements, id) {
    var elementos = [];
    var cat;
    if (id === null) {
      cat = elements.filter(e => e.parent === id);
    } else {
      cat = elements.filter(e => e.parent !== null && e.parent.id === id);
    }

    cat.sort(function (a, b) {
      if (Number(a.id) > Number(b.id)) {
        return 1;
      }
      if (Number(a.id) < Number(b.id)) {
        return -1;
      }
      return 0;
    });

    for (const e of cat) {
      const quest = this.structureQuestions(e.questions);
      const eleme = this.ListelementosCategories(elements, e.id);
      var peso = 0;
      if (quest.length !== 0) {
        for (const q of quest) {
          peso += q.ponderacion * q.peso / 100;
        }
      } else if (eleme.length !== 0) {
        for (const e of eleme) {
          peso += e.ponderacion * e.peso / 100;
        }
      }
      peso = Number(peso.toFixed(1));
      elementos.push({
        id: e.id,
        name: e.name,
        description: e.description,
        parent: e.parent,
        elementos: eleme,
        preguntas: quest,
        ponderacion: peso,
        peso: e.weighting
      });
    }
    return elementos;
  }

  private structureQuestions(questions) {
    var newQuestions = [];

    for (const q of questions) {
      var res = [];
      for (const r of q.answers_options) {
        res.push({
          id: r.id,
          descrip: r.description,
          score: r.score,
          questionId: q.id
        });
      }
      const answer = this.hojaRespuesta.find(c => Number(c.idPregunta) === Number(q.id));
      var valor = 0;
      res.sort(function (a, b) {
        if (Number(a.id) > Number(b.id)) {
          return 1;
        }
        if (Number(a.id) < Number(b.id)) {
          return -1;
        }
        return 0;
      });

      try {
        valor = res.find(c => Number(c.id) === Number(answer.idRespuesta)).score * 10 / 10;
      } catch (err) {
      }

      valor = Number(valor.toFixed(1));

      newQuestions.push({
        id: q.id,
        descripcion: q.description,
        order: q.order,
        requerida: q.required,
        respuestas: res,
        ponderacion: valor,
        peso: q.weighting
      });
    }
    newQuestions.sort(function (a, b) {
      if (Number(a.order) > Number(b.order)) {
        return 1;
      }
      if (Number(a.order) < Number(b.order)) {
        return -1;
      }
      return 0;
    });

    return newQuestions;
  }

  /**
   * ¿La asignación permite link público? Solo si su cuestionario acepta respuestas
   * múltiples (allowMultipleAnswers). Se resuelve por fila (element.cuesAsigId).
   */
  public permiteLinkAsignacion(element): boolean {
    const cuestionario = this.cuestionarios.find(c => Number(c.id) === Number(element?.cuesAsigId));
    return !!cuestionario && cuestionario.allowMultipleAnswers === true;
  }

  /**
   * Texto del tooltip del botón de encuestas enviadas: distingue "sin capturar"
   * de un total ya registrado (0 incluido).
   */
  public tooltipEncuestasEnviadas(element): string {
    const total = element?.encuestasEnviadas;
    if (total === null || total === undefined) {
      return this.translate.instant('cues.asignacion.registrarEnviadas');
    }
    return this.translate.instant('cues.asignacion.enviadasRegistradas') + ': ' + total;
  }

  /**
   * Captura manual del total de encuestas enviadas por correo a los colaboradores.
   * Solo aplica a asignaciones con link público (respuestas múltiples), porque son
   * las que se difunden por correo y no tienen un responsable único.
   * Dejar el campo vacío borra la captura (manda null).
   */
  public async registrarEncuestasEnviadas(element) {
    if (!this.permiteLinkAsignacion(element)) return;

    const actual = element?.encuestasEnviadas;
    const result = await Swal.fire({
      title: this.translate.instant('cues.asignacion.registrarEnviadas'),
      text: this.translate.instant('cues.asignacion.registrarEnviadasAyuda'),
      input: 'number',
      inputValue: actual === null || actual === undefined ? '' : String(actual),
      inputAttributes: { min: '0', step: '1' },
      showCancelButton: true,
      confirmButtonColor: '#ff6b00',
      cancelButtonColor: '#B9B9BC',
      confirmButtonText: this.translate.instant('acciones.acep'),
      cancelButtonText: this.translate.instant('acciones.cancel'),
      reverseButtons: true,
      customClass: {
        actions: 'aleema-swal-actions',
        confirmButton: 'aleema-swal-confirm',
        cancelButton: 'aleema-swal-cancel',
        input: 'aleema-swal-select'
      },
      inputValidator: (valor) => {
        // Vacío es válido: significa borrar la captura.
        if (valor === '' || valor === null) return null;
        const num = Number(valor);
        if (!Number.isInteger(num) || num < 0) {
          return this.translate.instant('cues.asignacion.enviadasInvalido');
        }
        return null;
      },
    });

    if (!result.isConfirmed) return;

    const total = result.value === '' || result.value === null ? null : Number(result.value);

    try {
      await firstValueFrom(this.asignacionesService.patchEncuestasEnviadas(element.id, total));
    } catch (err) {
      messages.errorMessageGraph(err);
      return;
    }

    // Se refleja en la fila sin recargar toda la tabla.
    element.encuestasEnviadas = total;
    const enLista = this.cuesAsignados.find(a => a.id === element.id);
    if (enLista) enLista.encuestasEnviadas = total;

    messages.succesMessageGraph(this.translate.instant('cues.asignacion.enviadasGuardado'));
  }

  /**
   * Genera el link público de UNA asignación y lo copia al portapapeles.
   * URL: /cuestionario/{hash}?q={cuestionarioId}&a={allocationToken}
   *  - hash = hash de la institución (getHash) -> alimenta catálogos, no se toca.
   *  - a    = token de la asignación (getAllocationToken) -> desambigua la ronda.
   * Se genera por fila (el allocationId ya existe), no en el form de creación.
   */
  public async copiarLinkAsignacion(element) {
    if (!this.permiteLinkAsignacion(element)) return;
    try {
      const [hashResp, tokenResp] = await Promise.all([
        firstValueFrom(this.asignacionesService.getHash(element.inst)),
        firstValueFrom(this.asignacionesService.getAllocationToken(element.id)),
      ]);
      const hash = hashResp?.['data']?.hash ?? hashResp?.['hash'];
      const token = tokenResp?.['data']?.token ?? tokenResp?.['token'];
      if (!hash || !token) {
        this.mensaje('cues.asignacion.linkError', 'error');
        return;
      }
      const link = `${window.location.origin}/cuestionario/${hash}?q=${element.cuesAsigId}&a=${token}`;
      await this.copiarAlPortapapeles(link);
    } catch (err) {
      this.mensaje('cues.asignacion.linkError', 'error');
    }
  }

  /** Copia texto al portapapeles, con fallback para navegadores antiguos */
  private async copiarAlPortapapeles(texto: string) {
    try {
      await navigator.clipboard.writeText(texto);
      this.mensaje('cues.asignacion.linkCopiado', 'success');
    } catch (err) {
      const textArea = document.createElement('textarea');
      textArea.value = texto;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      this.mensaje('cues.asignacion.linkCopiado', 'success');
    }
  }

}
